import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { LanguageProvider } from "@/contexts/LanguageContext";
import Header from "@/components/Header";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import Valuator from "@/pages/Valuator";
import Results from "@/pages/Results";
import Dashboard from "@/pages/Dashboard";
import SharedValuation from "@/pages/SharedValuation";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import Terms from "@/pages/Terms";
import Contact from "@/pages/Contact";
import Guide from "@/pages/Guide";
import Footer from "@/components/Footer";
import CookieBanner from "@/components/CookieBanner";

const Protected = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

const ScrollToTop = () => {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <AuthProvider>
          <BrowserRouter>
            <ScrollToTop />
            <Header />
            <Toaster position="top-center" richColors offset={72} mobileOffset={72} />
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/valutazione" element={<Valuator />} />
              <Route path="/risultato" element={<Results />} />
              <Route path="/cronologia" element={<Protected><Dashboard /></Protected>} />
              <Route path="/condivisa/:token" element={<SharedValuation />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="/termini" element={<Terms />} />
              <Route path="/contatti" element={<Contact />} />
              <Route path="/guide" element={<Guide />} />
              <Route path="/guide/:slug" element={<Guide />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <Footer />
            <CookieBanner />
          </BrowserRouter>
        </AuthProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
